
export const colors = {
  primary: "#7f1d1d",
  primaryHover: "#450a0a",
  link: "#b91c1c",
  secondary: "#991b1b",

  primaryLight: "#fef2f2",
  primaryLightBorder: "#fca5a5",
  sidebarSelected: "#FEE2E2",
  sidebarHover: "#FEF2F2",

  white: "#ffffff",
  black: "#111111",

  text: {
    primary: "#111111",
    secondary: "#637381",
    muted: "#6b7280",
  },

  border: {
    default: "#d1d5db",
    light: "#E6E8EE",
  },

  buttonDisabled: {
    background: "#e5e7eb",
    color: "#9ca3af",
  },

  gradient: {
    g1: "#b91c1c",
    g2: "#991b1b",
    g3: "#7f1d1d",
    g4: "#6b1717",
    g5: "#5c1212",
    g6: "#450a0a",
    g7: "#2d0707",
    g8: "#1a0404",
  },

  accent: {
    coral: "#f07167",
  },
};

export const heroGradient = `linear-gradient(
  90deg,
  ${colors.gradient.g1} 0%,
  ${colors.gradient.g2} 12%,
  ${colors.gradient.g3} 24%,
  ${colors.gradient.g4} 36%,
  ${colors.gradient.g5} 48%,
  ${colors.gradient.g6} 60%,
  ${colors.gradient.g7} 76%,
  ${colors.gradient.g8} 100%
)`;

export const primaryGradient = `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`;

export default colors;
